<dls-login id="login-page" [applicationName]='LOGIN_APP_TITLE'>
	<div class="login-info-version">
		<gen-info-menu class="info-menu" id="loginInfoMenu" [isFromLogin]="true"></gen-info-menu>
		<small class="login-version" id="loginVersion">{{version}}</small>
	</div>
	<dls-progress-circular-indeterminate *ngIf="loading; else login_form" class="pt-circular-medium"
		[labelText]="labelText">
	</dls-progress-circular-indeterminate>
	<ng-template #login_form>
		<form #loginForm="ngForm" name="login-form" id="Login-from" class="pt-login-form" (ngSubmit)="login(user)">
			<dls-textbox hideClearButton="true">
				<input dlsInput [placeholder]="LOGIN_NAME_TITLE" [(ngModel)]="user.loginId" name="loginId"
					type="email" required> <!-- pattern="[\.a-zA-Z\-0-9]+@[a-zA-Z\.0-9]+" -->
			</dls-textbox>
			<dls-password class="pt-login-password">
				<input dlsinput autocomplete="off" autocorrect="off" autocapitalize="off" spellcheck="false"
					[placeholder]="LOGIN_PASSWORD_TITLE" [(ngModel)]="user.password" name="password" required>
			</dls-password>

      <dls-tooltip *ngIf="loginErrorMessage" class="tooltip-error-message pt-tooltip pt-visible pt-validator pt-bottom">
        <section>
          <dls-icon class="pt-icon icon-dls-info validator-info"></dls-icon>
          {{loginErrorMessage}}
        </section>
      </dls-tooltip>

      <button dlsButton class="pt-primary pt-extra-wide pt-login-button"
              [ngClass]="{'adapt-for-error-message' : loginErrorMessage && !ieService.isIE(), 'adapt-for-error-message-IE' : loginErrorMessage && ieService.isIE()}" translate>{{LOGIN_BUTTON_TITLE}}</button>

      <button dlsButton class="pt-quiet-default pt-extra-wide pt-login-button" type="button"
				(click)="navigateToForgotPassword()" translate>{{FORGOT_PASSWORD_TITLE}}</button>
		</form>
	</ng-template>

	<button dlsButton class="privacy-note pt-quiet-default pt-extra-wide pt-login-button" type="button"
		(click)="loadPrivacyNotes()" translate>{{PRIVACY_NOTES_TITLE}}</button>
	<div *ngIf="forTestingPurposesOnly" class="login-msg" translate>
		{{forTestingPurposesOnlyMessage}}
	</div>
	<div class="pt-login-footer">
		<div class="pt-footer-paragraph" translate>
			<p>{{COPYRIGHT_CONTENT}}</p>
		</div>
	</div>
</dls-login>
